import React, { Component } from 'react'
import R from 'ramda'
import {
  Button,
  Modal,
  Select,
  TextInput,
} from 'advenio-components'
import PropTypes from 'prop-types'
import Slider from 'rc-slider'
import styled from 'styled-components'
import { Form } from 'formsy-react'
import 'rc-slider/assets/index.css'
import Switch from '../CustomButtons/Switch'
import {
  HeaderTitle,
  NameHeader,
  Close,
  Save,
  SwitchDiv,
  SwitchTopDiv,
  Span,
  Observations,
  Textarea,
  Img,
  HeaderSpan,
  NameSpan,
  Content,
  TemperatureContainer,
  TemperatureDiv,
  TemperatureText,
  TemperatureNumber,
  TemperatureSlider,
  SliderDiv,
  QuestionsContainer,
  QuestionsDiv,
  ReviseDiv,
  DivAskParent,
  SwitchContainer,
  Question,
  IconsDiv,
  ActionButton,
  Check,
  SelectContainer,
  HomeReportDiv,
  HomeReportDiv2,
  SpanHomeReport,
  HomeReportTitle,
  HomeReportContainer,
  ParentDiv,
  ParentContainer,
  SwitchYes,
  SwitchNo,
  SwitchParentContainer,
} from './ModalAssessment.styles'
import { HIGH_TEMPERATURE } from '../../Constants'

let classrooms = []

const CheckContainer = styled.div`
  height: 50px;
  width: 95%;
  position: relative;
  overflow: hidden;
  display: flex;
  cursor: pointer;
  background-color: ${props => (props.selected ? '#4A90E2' : '')};
  margin-bottom: 5px;
  margin-top: 5px;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  border-radius: 5px;
  border: solid 1px #cccccc;
`

const Buttons = styled.button`
  color: ${props => (props.selected ? '#FFF' : '')};
  background-color: transparent;
  height: 100%;
  width: 100%;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  border: solid 0.5px transparent;
`
const Input = styled.input`
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  height: 100%;
  width: 100%;
  cursor: pointer;
`
const HR = styled.span`
  font-weight:bold;
`

const initialState = {
  close: false,
  color: '#75B753',
  temperature: 36.5,
  extra: [],
  revise: [],
  askParent: [],
  classrooms: [],
  room: '#75B753',
  goTo: 'Pasar a Sala',
  goToMovil: 'Pasar a Sala',
  icon: '/assets/checkRoom.svg',
  isParentPresent: true,
  showParentQuestion: false,
}

class ModalAssessment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      close: false,
      width: 0,
      color: '#75B753',
      temperature: 36.5,
      extra: [],
      revise: [],
      askParent: [],
      classrooms: [],
      room: '#75B753',
      goTo: 'Pasar a Sala',
      goToMovil: 'Pasar a Sala',
      icon: '/assets/checkRoom.svg',
      isParentPresent: true,
      showParentQuestion: false,
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const extra = R.clone(this.props.extra)
    const revise = R.clone(this.props.revise)
    const askParent = R.clone(this.props.askParent)

    setTimeout(() => {
      if (this.scrollArea) {
        this.scrollArea.scrollTop = 1
        this.scrollArea.addEventListener('scroll', this.preventIOSScroll)
      }
    }, 250)

    if (extra) {
      for (let i = 0; i < extra.length; i++) {
        extra[i].selected = false
        extra[i].details = ''
      }
    }
    if (revise) {
      for (let i = 0; i < revise.length; i++) {
        revise[i].selected = false
      }
    }
    if (askParent) {
      for (let i = 0; i < askParent.length; i++) {
        askParent[i].selected = false
      }
    }
    if (nextProps.virtual) {
      classrooms = R.clone(nextProps.centerClassroom)
      for (let i = 0; i < classrooms.length; i++) {
        classrooms[i].label = classrooms[i].name
        classrooms[i].value = classrooms[i].id
      }
    }
    this.setState({ extra, revise, askParent, classrooms })
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   let showParentQuestion = false
  //   if (nextState.goTo === 'Mandar a Casa') {
  //     showParentQuestion = true
  //   }
  //   this.setState({ showParentQuestion})
  //   return true
  // }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
    if (this.scrollArea) {
      this.scrollArea.removeEventListener('scroll', this.preventIOSScroll)
    }
  }

  onClose = () => {
    this.setState({ close: true })
  }

  onChange = index => (e) => {
    const newState = { ...this.state }
    for (let i = 0; i < newState.extra.length; i++) {
      if (i == index) {
        newState.extra[i].selected = true
        newState.extra[i].details = e.target.value
      }
    }
    this.setState(newState, this.goTo)
  }

  getExtraQuestions = () => {
    const { extra } = this.state

    if (!extra) {
      return null
    }

    return extra.map((question, index) => (
      <SwitchDiv key={question.id}>
        <TextInput
          name={`question-${question.id}`}
          label={question.question}
          onChangeCallback={this.onChange(index)}
          hideEmptyHelpBlock
        />
      </SwitchDiv>
    ))
  }

  getReviseQuestions = () => {
    const { revise } = this.state
    return revise
      ? revise.map((reviseQuestion, index, array) =>
          //eslint-disable-line
        (
          <CheckContainer key={reviseQuestion.id} selected={reviseQuestion.selected}>
            <Input
              id={reviseQuestion.id}
              type="radio"
              checked={reviseQuestion.selected}
              onClick={() => this.clickRevise(index)}
            />
            <Buttons
              onClick={() => this.clickRevise(index)}
              selected={reviseQuestion.selected}
              type="button"
            >
              <Check
                src={
                  reviseQuestion.selected
                    ? '/assets/check_mark.svg'
                    : '/assets/blank_check_mark.svg'
                }
              />
              {reviseQuestion.question}
            </Buttons>
          </CheckContainer>
        ),
      )
      : null
  }

  getAskParentQuestions = () => {
    const { askParent } = this.state
    return askParent
      ? askParent.map((parentQuestion, index, array) =>
          //eslint-disable-line
        (
          <CheckContainer key={parentQuestion.id} selected={parentQuestion.selected}>
            <Input
              onClick={() => this.clickAskParent(index)}
              id={parentQuestion.id}
              type="radio"
            />
            <Buttons
              onClick={() => this.clickAskParent(index)}
              selected={parentQuestion.selected}
              type="button"
            >
              <Check
                src={
                  parentQuestion.selected
                    ? '/assets/check_mark.svg'
                    : '/assets/blank_check_mark.svg'
                }
              />
              {parentQuestion.question}
            </Buttons>
          </CheckContainer>
        ),
      )
      : null
  }

  preventIOSScroll = (e) => {
    const elem = e.currentTarget
    const top = elem.scrollTop
    const totalScroll = elem.scrollHeight
    const currentScroll = top + elem.offsetHeight

    if (top === 0) {
      elem.scrollTop = 1
    } else if (currentScroll === totalScroll) {
      elem.scrollTop = top - 1
    }
  }

  changeColor = () => {
    let count = 0
    for (let i = 0; i < this.state.revise.length; i++) {
      if (this.state.revise[i].selected) {
        count += 1
      }
    }
    for (let i = 0; i < this.state.askParent.length; i++) {
      if (this.state.askParent[i].selected) {
        count += 1
      }
    }
    if (this.state.temperature >= HIGH_TEMPERATURE) {
      this.setState({
        color: '#EA3B3B',
        room: '#9B9B9B',
        goTo: 'Mandar a Casa',
        goToMovil: 'Mandar a Casa',
        icon: '/assets/home_icon.svg',
      })
    } else if (count === 0 && this.state.goTo !== 'Mandar a Casa') {
      this.setState({
        color: '#75B753',
        room: '#75B753',
        goTo: 'Pasar a Sala',
        goToMovil: 'Pasar a Sala',
        icon: '/assets/checkRoom.svg',
      })
    } else {
      this.goTo()
    }
  }

  clickExtra = (index) => {
    const newState = { ...this.state }
    newState.extra[index].selected = !newState.extra[index].selected
    this.setState(newState, this.goTo)
  }

  clickRevise = (index) => {
    const newState = { ...this.state }
    newState.revise[index].selected = !newState.revise[index].selected
    this.setState(newState, this.goTo)
  }

  clickAskParent = (index) => {
    const newState = { ...this.state }
    newState.askParent[index].selected = !newState.askParent[index].selected
    this.setState(newState, this.goTo)
  }

  goTo = () => {
    const newState = { ...this.state }
    let home = 0
    let classroom = 0
    let nursesRoom = 0
    let count = 0
    for (let i = 0; i < newState.revise.length; i++) {
      if (newState.revise[i].selected) {
        count++
        if (newState.revise[i].destination == 'Home') {
          home++
        } else if (newState.revise[i].destination == "Nurse's Room") {
          nursesRoom++
        } else {
          classroom++
        }
      }
    }
    for (let i = 0; i < newState.extra.length; i++) {
      if (newState.extra[i].selected) {
        count++
        if (newState.extra[i].destination == 'Home') {
          home++
        } else if (newState.extra[i].destination == "Nurse's Room") {
          nursesRoom++
        } else {
          classroom++
        }
      }
    }
    for (let i = 0; i < newState.askParent.length; i++) {
      if (newState.askParent[i].selected) {
        count++
        if (newState.askParent[i].destination == 'Home') {
          home++
        } else if (newState.askParent[i].destination == "Nurse's Room") {
          nursesRoom++
        } else {
          classroom++
        }
      }
    }
    if (home > 0) {
      newState.room = '#9B9B9B'
      newState.goTo = 'Mandar a Casa'
      newState.goToMovil = 'Mandar a Casa'
      newState.icon = '/assets/home_icon.svg'
    } else if (nursesRoom > 0) {
      newState.room = '#C50315'
      newState.goTo = 'Pasar a Sintomas'
      newState.goToMovil = 'Pasar a Sintomas'
      newState.icon = '/assets/NursesRoom.svg'
    } else {
      newState.room = '#75B753'
      newState.goTo = 'Pasar a Sala'
      newState.goToMovil = 'Pasar a Sala'
      newState.icon = '/assets/checkRoom.svg'
    }
    if (count === 0) {
      newState.showParentQuestion = false
    }
    this.setState(newState)
  }

  handleChange = (temperature) => {
    const realValue = temperature / 10
    this.setState({ temperature: realValue }, () => this.changeColor())
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  closeModal = () => {
    this.props.closeAssessment()
    this.setState(initialState)
  }

  send = (data) => {
    const infoToSend = []
    let params = ''
    for (let i = 0; i < this.state.extra.length; i++) {
      if (this.state.extra[i].selected) {
        infoToSend.push({
          question_id: this.state.extra[i].id,
          details: this.state.extra[i].details,
        })
      }
    }
    for (let i = 0; i < this.state.revise.length; i++) {
      if (this.state.revise[i].selected) {
        infoToSend.push({ question_id: this.state.revise[i].id })
      }
    }
    for (let i = 0; i < this.state.askParent.length; i++) {
      if (this.state.askParent[i].selected) {
        infoToSend.push({ question_id: this.state.askParent[i].id })
      }
    }
    if (this.props.virtual) {
      params = {
        classroom_id: data.classroom,
        temperature: this.state.temperature,
        observations: infoToSend,
        parent_present: this.state.isParentPresent,
      }
      window.gtag('event', 'Checkin Virtual', {
        event_category: 'Check',
        event_label: 'click Checkin Virtual',
        // value: Number(id)
          })
      this.props.postChildVirtualHealthCheck(this.props.child, params)
    } else {
      params = {
        temperature: this.state.temperature,
        observations: infoToSend,
        parent_present: this.state.isParentPresent,
      }
      window.gtag('event', 'Check', {
        event_category: 'Check',
        event_label: 'click Check',
        // value: Number(id)
          })
      this.props.postChildHealthCheck(this.props.child.id, params, this.props.isTeacher, this.props.fromProfile)
    }
  }

  togglePresentParent = (e) => {
    if (e.currentTarget.id === 'yes') {
      this.setState({
        isParentPresent: true,
        goTo: 'Mandar a Casa',
        room: '#9B9B9B',
        icon: '/assets/home_icon.svg',
      })
    } else {
      this.setState({
        isParentPresent: false,
        goTo: 'Pasar a Sintomas',
        room: '#C50315',
        icon: '/assets/NursesRoom.svg',
      })
    }
  }

  render() {
    return (
      <Modal
        isOpened={this.props.open}
        full={this.state.width < 763}
        onClose={()=>this.closeModal()}
        statePath="healthCheck"
        actionType="sending"
        typePrefix="HEALTH_CHECK"
      >
        <Form onSubmit={this.send}>
          <HeaderTitle room={this.state.room}>
            <Close>
              <Img src="/assets/closeAssessment.svg" onClick={() => this.closeModal()} />
            </Close>
            <HeaderSpan>
              <img src={this.state.icon} style={{ paddingRight: '5px' }} />
              <span>Valoracion Diaria</span>
            </HeaderSpan>
            <NameHeader>
              <NameSpan>
                {`${this.props.child.first_name} ${this.props.child.last_name_paternal}`}
              </NameSpan>
            </NameHeader>
            <Save>
              <Button
                small
                style={this.state.width < 763 ? { fontSize: '9px' } : {}}
                primary
                type="submit"
                loading={this.props.loading}
              >
                {this.state.width < 763 ? this.state.goToMovil : this.state.goTo}
              </Button>
            </Save>
          </HeaderTitle>
          <Content
            innerRef={(el) => {
              this.scrollArea = el
            }}
          >
            {this.props.virtual ? (
              <SelectContainer>
                <Select
                  name="classroom"
                  label="Selecciona salon a asignar"
                  value={this.state.classrooms.length > 0 ? this.state.classrooms[0].value : 1}
                  options={this.state.classrooms}
                />
              </SelectContainer>
            ) : (
              ''
            )}
            {!R.isEmpty(this.props.studentHomeReport) ? (
              <HomeReportContainer>
                <HomeReportDiv>
                <HomeReportDiv2>
                  <HomeReportTitle>Home Report</HomeReportTitle>
                  <SpanHomeReport>Temperatura: <HR>{this.props.studentHomeReport.temperature} °C</HR></SpanHomeReport>
                  <SpanHomeReport>El tutor o Bebé ha tenido un sintoma de vias Respiratorias: <HR>{this.props.studentHomeReport.respiratory_disease ? 'SI' : 'NO'}</HR></SpanHomeReport>
                  <SpanHomeReport>El tutor o Bebé ha estado en contacto con algun diagnosticado de COVID-19: <HR>{this.props.studentHomeReport.contact_sick ? 'SI' : 'NO'}</HR></SpanHomeReport>
                  <SpanHomeReport>El tutor o Bebé ha viajado fuera de la ciudad en los últimos 14 días: <HR>{this.props.studentHomeReport.trip ? 'SI' : 'NO'}</HR></SpanHomeReport>
                </HomeReportDiv2>
                </HomeReportDiv>
              </HomeReportContainer>
              ):''}
            <TemperatureContainer>
              <TemperatureDiv>
                <TemperatureText>
                  <Span>TEMPERATURA</Span>
                  <TemperatureNumber>{`${this.state.temperature} ºC`}</TemperatureNumber>
                </TemperatureText>
                <TemperatureSlider>
                  <SliderDiv>
                    <Slider
                      allowCross={false}
                      min={350}
                      max={420}
                      count={1}
                      onChange={value => this.handleChange(value)}
                      trackStyle={[{ backgroundColor: this.state.color }]}
                      handleStyle={[
                        {
                          backgroundColor: '#FFFFFF',
                          border: '#FFFFFF',
                          height: '25px',
                          width: '25px',
                          marginTop: '-10px',
                        },
                      ]}
                      railStyle={{ backgroundColor: '#CCCCCC' }}
                    />
                  </SliderDiv>
                </TemperatureSlider>
              </TemperatureDiv>
            </TemperatureContainer>
            {this.state.goTo === 'Mandar a Casa' || this.state.showParentQuestion ? (
              <ParentContainer>
                <ParentDiv>
                  <span>¿ Se encuentra presente el tutor para llevarse al niño ?</span>
                  <SwitchParentContainer>
                    <SwitchYes
                      id="yes"
                      active={this.state.isParentPresent}
                      onClick={ (e) => this.togglePresentParent(e)}
                    >
                      SI
                    </SwitchYes>
                    <SwitchNo
                      id="no"
                      active={!this.state.isParentPresent}
                      onClick={ (e) => this.togglePresentParent(e)}
                    >
                      NO
                    </SwitchNo>
                  </SwitchParentContainer>
                </ParentDiv>
              </ParentContainer>
            ) : (
              ''
            )}
            <QuestionsContainer virtual={this.props.virtual}>
              <QuestionsDiv>
                <ReviseDiv>
                  <span>Revisar</span>
                  {this.getReviseQuestions()}
                </ReviseDiv>
                <DivAskParent>
                  <span>Preguntar</span>
                  {this.getAskParentQuestions()}
                </DivAskParent>
              </QuestionsDiv>
            </QuestionsContainer>
            <SwitchContainer>{this.getExtraQuestions()}</SwitchContainer>
          </Content>
        </Form>
      </Modal>
    )
  }
}

ModalAssessment.propTypes = {
  closeAssessment: PropTypes.func,
  postChildHealthCheck: PropTypes.func,
  postChildVirtualHealthCheck: PropTypes.func,
  child: PropTypes.object,
}
ModalAssessment.defaultProps = {
  // closeAssessment: () => {},
  postChildHealthCheck: () => {},
  postChildVirtualHealthCheck: () => {},
  child: {},
}

export default ModalAssessment



// WEBPACK FOOTER //
// ./src/Components/ModalContainer/ModalAssessment.jsx